module.exports = __webpack_public_path__ + "img/bg1.c2920e05.jpg";